<template>
  <hm-content title>
    <iframe :src="iframeUrl" class="iframe"></iframe>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
       iframeUrl: "",
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryDict();
  },
  methods: {
    async queryDict() {
      const { result } = await this.$store.dispatch("queryDict", {
        textCode: "reporting_services"
      });
      this.iframeUrl = result.textContentZhCn;
    },
  },
};
</script>
<style lang="scss" scoped>
.iframe{
  width: 100%;
  height: 75vh;
  border: none;
  background: none;
}
</style>